// extracted by mini-css-extract-plugin
export default {"content":"Modal_content__EO4pI","icon":"Modal_icon__UCONf","button":"Modal_button__NHOTQ"};